import dateformat from 'dateformat';
import {get, isNil} from 'lodash';
import PropTypes from 'prop-types';
import {DateInput} from 'semantic-ui-calendar-react';
import {Checkbox, Form} from 'semantic-ui-react';
import './CustomiseCoverPageDetailsForm.scss';

const onChangeProxy = (onChange) => {
  return (e, {checked, name, type}) => {
    return onChange(e, {
      name: `${ name }_isEnabled`,
      type,
      value: isNil(checked) ? 'false' : checked.toString(),
    });
  };
};

const isEnabled = ({sectionData, dataKeyPath}) => {
  return get(sectionData, `${ dataKeyPath }_isEnabled`, 'true') === 'true';
};

const OptionalInput = ({dataKeyPath, label, placeholder, sectionData, onChange}) => {
  return (
    <Form.Field className={ `property ${ label.toLowerCase().replace(' ', '_') }` }>
      <Checkbox
        name={ dataKeyPath }
        label={ label }
        checked={ isEnabled({sectionData, dataKeyPath}) }
        onChange={ onChangeProxy(onChange) }
      />
      <Form.Input
        disabled={ !isEnabled({sectionData, dataKeyPath}) }
        placeholder={ placeholder }
        name={ dataKeyPath }
        value={ get(sectionData, dataKeyPath) || '' }
        onChange={ onChange }
      />
    </Form.Field>
  );
};

OptionalInput.propTypes = {
  dataKeyPath: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  sectionData: PropTypes.object,
  onChange: PropTypes.func,
};

const OptionalDateInput = ({dataKeyPath, label, placeholder, sectionData, onChange}) => {
  return (
    <Form.Field className={ `property ${ label.toLowerCase().replace(' ', '_') }` }>
      <Checkbox
        name={ dataKeyPath }
        label={ label }
        checked={ isEnabled({sectionData, dataKeyPath}) }
        onChange={ onChangeProxy(onChange) }
      />
      <DateInput
        disabled={ !isEnabled({sectionData, dataKeyPath}) }
        name={ dataKeyPath }
        startMode="day"
        placeholder={ placeholder }
        value={ get(sectionData, dataKeyPath) || '' }
        dateFormat="Do MMMM YYYY"
        onChange={ onChange }
        closable
      />
    </Form.Field>
  );
};

OptionalDateInput.propTypes = {
  dataKeyPath: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  sectionData: PropTypes.object,
  onChange: PropTypes.func,
};

const OptionalTwoInput = ({dataKeyPath1, dataKeyPath2, label, placeholder1, placeholder2, sectionData, onChange}) => {
  return (
    <Form.Field className={ `property ${ label.toLowerCase().replace(' ', '_') }` }>
      <Checkbox
        name={ dataKeyPath1 }
        label={ label }
        checked={ isEnabled({sectionData, dataKeyPath: dataKeyPath1}) }
        onChange={ onChangeProxy(onChange) }
      />
      <Form.Input
        disabled={ !isEnabled({sectionData, dataKeyPath: dataKeyPath1}) }
        placeholder={ placeholder1 }
        name={ dataKeyPath1 }
        value={ get(sectionData, dataKeyPath1, '') }
        onChange={ onChange }
      />
      <Form.Input
        disabled={ !isEnabled({sectionData, dataKeyPath: dataKeyPath1}) }
        placeholder={ placeholder2 }
        name={ dataKeyPath2 }
        value={ get(sectionData, dataKeyPath2, '') }
        onChange={ onChange }
      />
    </Form.Field>
  );
};

OptionalTwoInput.propTypes = {
  dataKeyPath1: PropTypes.string,
  dataKeyPath2: PropTypes.string,
  label: PropTypes.string,
  placeholder1: PropTypes.string,
  placeholder2: PropTypes.string,
  sectionData: PropTypes.object,
  onChange: PropTypes.func,
};

const CustomiseCoverPageDetailsForm = ({sectionData, onChange, onSubmit}) => (
  <div id="customise-cover-details-form">
    <Form onSubmit={ onSubmit } widths="equal">
      <OptionalInput
        dataKeyPath="title"
        label="Report title"
        placeholder="Comparative Market Analysis"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="preparedFor"
        label="Prepared for"
        placeholder="Your Client"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalDateInput
        dataKeyPath="preparedOn"
        label="Prepared on"
        placeholder={ dateformat(new Date(), 'dS mmmm yyyy') }
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="singleLineAddress"
        label="Property address"
        placeholder={ get(sectionData, 'singleLineAddress', 'Some Address') }
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="agentName"
        label="Agent name"
        placeholder="Your Name"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="agency"
        label="Agency name"
        placeholder="Your Agency"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalTwoInput
        dataKeyPath1="agencyAddress"
        dataKeyPath2="agencyAddress2"
        label="Agency address"
        placeholder1="Address line 1"
        placeholder2="Address line 2"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="landline"
        label="Landline"
        placeholder="xx xxxx xxxx"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="mobile"
        label="Mobile"
        placeholder="xxxx xxx xxx"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <OptionalInput
        dataKeyPath="email"
        label="Email"
        placeholder="your@email.address"
        sectionData={ sectionData }
        onChange={ onChange }
      />
      <Form.Group>
        <Checkbox name="agentPhoto" label="Photo" checked={ isEnabled({sectionData, dataKeyPath: 'agentPhoto'}) } onChange={ onChangeProxy(onChange) }/>
        <Checkbox name="agencyLogo" label="Logo" checked={ isEnabled({sectionData, dataKeyPath: 'agencyLogo'}) } onChange={ onChangeProxy(onChange) }/>
      </Form.Group>
    </Form>
  </div>
);

CustomiseCoverPageDetailsForm.propTypes = {
  sectionData: PropTypes.object,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default CustomiseCoverPageDetailsForm;